import React from 'react';
import './Hero.css';

const Hero = () => {
  // Photos for the scrolling background
  const scrollingPhotos = [
    '/images/AndarBosnianCoffee2.jpeg',
    '/images/CatOnBridge5.jpeg',
    '/images/Child.jpeg',
    '/images/OldTownAlley.jpeg',
    '/images/Baklava1.jpeg',
    '/images/CatOnBridge4.jpeg',
    '/images/EuropeanStyleBuilding.jpeg',
    '/images/AndarCafe.jpeg',
    '/images/OttomonDistrict.jpeg',
    '/images/Bosnian Flag.jpeg'
  ];

  return (
    <section id="home" className="hero">
      {/* Scrolling photo background */}
      <div className="scrolling-background">
        <div className="scrolling-track">
          {/* Duplicate the photos for seamless loop */}
          {[...scrollingPhotos, ...scrollingPhotos, ...scrollingPhotos].map((photo, index) => (
            <img
              key={index}
              src={photo}
              alt="Travel photography"
              className="scrolling-photo"
            />
          ))}
        </div>
      </div>

      {/* Content overlay */}
      <div className="hero-overlay">
        <div className="hero-content">
          <div className="hero-text">
            <h1>Stories Live in<br />the People You Meet</h1>
            <p>
              A digital nomad documenting authentic human connections and unexpected
              detours from around the world, one frame at a time.
            </p>
            <button
              className="cta-button"
              onClick={() => document.getElementById('gallery').scrollIntoView({ behavior: 'smooth' })}
            >
              Explore Work
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;